module.exports = __webpack_public_path__ + "static/media/associates_icon_dark.93478fa0.svg";